import React,{useState,useRef} from 'react'
import {isEmail } from './OYMData';
import { getAuth, signInWithEmailAndPassword,createUserWithEmailAndPassword,sendEmailVerification,updateProfile,setPersistence,sendPasswordResetEmail,browserSessionPersistence,browserLocalPersistence   } from "firebase/auth";
import {sessionStatusStates} from './myFunctions';
export default function Signon({oym,status,setSessionStatus}) {
    console.log(status);
    const [isNewUser,setNewUser] = useState (false);
    const emailAddressRef = useRef();
    const confirmPasswordRef = useRef();
    const passwordRef = useRef();
    const newUserRef = useRef();
    const sessionPersistanceRef = useRef();
    const seed="Dcktbg49$)x";
    console.log("in signon !x!");
    function newUserChange(e){
        console.log("New user toggled:",newUserRef.current.checked,status);
        if (newUserRef.current.checked){
            // setSessionStatus(sessionStatusStates.newUser);
            setNewUser(true);
        } else {
            // setSessionStatus(sessionStatusStates.notAuthenticated);
            setNewUser(false);
        }
    }
    function sessionPersistanceChange(e){
        console.log("Changed session persistance:"+sessionPersistanceRef.current.checked);
    }
    function submitSignUp(e){
        console.log("signing up");
        let email=emailAddressRef.current.value;
        let password=passwordRef.current.value;
        let confirmPassword=confirmPasswordRef.current.value;
        if (!isFieldsOK(email,password,confirmPassword)){
            return;
        }
        let friend=oym.isEmail(email);
        console.log(friend);
        console.log(email);
        console.log(password);
        if (password!==confirmPassword){
            alert("Passwords do not match.   Please reenter both passwords.");
            passwordRef.current.value=null;
            confirmPasswordRef.current.value=null;
            return;
        }
        // if (friend){
            const auth = getAuth();
            createUserWithEmailAndPassword(auth, email, password).then((userCredential) => {
                // Signed in 
                console.log(userCredential);
                const user = userCredential.user;
                console.log(user);
                updateProfile(auth.currentUser, {
                    displayName: friend.name
                  }).then(() => {
                    sendEmailVerification(user).then( ()=>
                    {
                        console.log("Email verification sent");
                        setSessionStatus(sessionStatusStates.waitingEmailVerification);
                        console.log("Session status set to ",sessionStatusStates.waitingEmailVerification);
                    })
                    .catch( (error)=>{  // catch send email verification error
                    console.log("Email verification sending failed ",error);
                    const errorCode = error.code;
                    alert("An attempt to send an email for verification failed. This may be an internal error."+
                          "Please contact OYM technical support and provide them with this code->"+'"'+errorCode+'"');
                    })
                    console.log("Successfull ",user);
                  }).catch((error) => { // catch update profile error
                    console.log("Updating display name failed ",error);
                    const errorCode = error.code;
                    alert("An error occured updating your security profile. This may be an internal error."+
                          "Please contact OYM technical support and provide them with this code->"+'"'+errorCode+'"');
                  });                  
            })
                .catch((error) => {  // catch createUserWithEmailAndPassword error
                console.log("failed ",error);
                const errorCode = error.code;
                const errorMessage = error.message;
                if (errorCode==="auth/email-already-in-use") {
                    alert("It appears that thee is already signed up.  Please unclick the 'New User' checkbox and try again.")
                } else {
                    alert("Signup failed. "+errorMessage); 
                }
            });
        // } else {
        //     alert("Email not on file.")
        // }
    }
    function submitSignIn(e){
        const auth = getAuth();
        let email=emailAddressRef.current.value;
        let password=passwordRef.current.value;
        let sessionPersistance=sessionPersistanceRef.current.checked;
        console.log("Beginning submitSignIn sessionPersistance:"+sessionPersistanceRef.current.checked);
        if (!isFieldsOK(email,password)){
            return;
        }
        signInWithEmailAndPassword(auth, email, password)
        .then((userCredential) => {
            console.log("signInWithEmailAndPassword then #1")
            const user = userCredential.user;
            if (!user.emailVerified){
                // It is not imagined that this could ever happen unless the user enters in the 
                // seed password.  In any event, treat it like a new user and do not authorize.
                setToNewUser();
                alert("Internal error.  Invalid use of password.  Contact technical support.")
                return;
            }
            // Signed in 
            console.log("signInWithEmailAndPassword then #2 sessionPersistance:"+sessionPersistance);
            if (sessionPersistance){
                setPersistence(auth, browserLocalPersistence).then(() => {
                    console.log("Session persistance set to local");
                    setStatusByUserEmail(userCredential);
                })
                    .catch((error) => {
                        alert("An error occured trying to ensure that thee will stay logged on:"+error.message);
                    }
                )    
            } else {
                setPersistence(auth, browserSessionPersistence).then(() => {
                    console.log("Session persistance set to session");
                    setStatusByUserEmail(userCredential);
                })
                .catch((error) => {
                    alert("An error occured trying to ensure that thee will be logged off after shutting down thy browser:"+error.message);
                }
            )}
        })
            .catch((error) => {
             const errorCode = error.code;
             const errorMessage = error.message;
             console.log("signInWithEmailAndPassword catch ",errorCode,errorMessage);  //
            //  if (!user.emailVerified){
            //     alert("Thee has not set thy initial password.   Please click on the 'New User' checkbox and try again.");
            //  }
             if (errorCode==="auth/wrong-password"){
                passwordRef.current.value=null;
                seedSignon(auth,email);  // try seed to make sure that they are not first time user.
                // alert("Invalid password.  Please try again.");
             } else if (errorCode==="auth/user-not-found")  {
                alert("It appears that thee has not signed up for access to this system.  "+
                    "Please confirm that the email thee entered is correct.  If the email address is correct, click on the 'New User' checkbox and signup.");
             } else {
                alert("signin failed:"+errorMessage);
             }
        });
    }
    function submitPasswordReset(e){
        let email=emailAddressRef.current.value;
        console.log("submitting password reset for "+email);
        if (email===null|email===""){
            alert("Enter email address for password reset.")
        } else {
            let friend=oym.isEmail(email);
            // if (friend){
                const auth = getAuth();
                sendPasswordResetEmail(auth, email)
                .then(() => {
                    alert("An email has been sent to "+email+" which can be used to reset thy password.");
                    setSessionStatus(sessionStatusStates.passwordChange);
                    setNewUser(false);
                    newUserRef.current.checked=false;
                })
                 .catch((error) => {
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    if (errorCode==='auth/user-not-found'){
                        alert("The email address thee entered is not on our files.  One must be a current user to use the password reset function.")
                    } else {
                       alert("Unable to send password reset email. "+errorMessage);
                    }
                });
            // } else {
            //     alert(email+" is not in the Yearly Meeting's files.");
            // }
        }
    }
    function setStatusByUserEmail(userCredential){
        const user = userCredential.user;
        if (user.emailVerified){
            setSessionStatus(sessionStatusStates.signonCompleted)
        } else {
            setSessionStatus(sessionStatusStates.waitingEmailVerification);
        }
    }
    function setToNewUser(){
        setSessionStatus(sessionStatusStates.newUser);
        setNewUser(true);
        newUserRef.current.checked=true;
    }
    function seedSignon(auth, email){
        console.log("seedSignon Start");
        signInWithEmailAndPassword(auth, email, seed)
        .then((userCredential) => {
            console.log("seedSignon then");
            const user = userCredential.user;
            // Signed in through seed
            console.log("Signed in through seed");
            if (user.emailVerified){
                alert("Internal seed error #2.  Contact technical support.");
            } else {
                alert("You must initialize your password via email before you use this system.");
                setToNewUser();
            }
        })
            .catch((error) => {
             const errorCode = error.code;
             const errorMessage = error.message;  //
             console.log("seedSignon catch",errorCode,errorMessage);
            //  if (!user.emailVerified){
            //     alert("Thee has not set thy initial password.   Please click on the 'New User' checkbox and try again.");
            //  }
             if (errorCode==="auth/wrong-password"){
                passwordRef.current.value=null;
                alert("Invalid password.  Please try again.");
                // classic invalid password entered, then tried seed password to make sure not first time user.  But really was invalid password.
             } else if (errorCode==="auth/user-not-found")  { // in theory cannot happen since it was tested with user entered password.
                alert("It appears that thee has not signed up for access to this system.  "+
                    "Please confirm that the email thee entered is correct.  If the email address is correct, click on the 'New User' checkbox and signup.");
             } else {
                alert("seed signin failed:"+errorMessage);
             }
        });
    }
    // let oym= new OYMData(); 
    // console.log(oym.isEmail("charles.c.thomas.jr@gmail.com"));
    // console.log(oym);
    let confirmPasswordComponent = ""; // deprecated
    let passwordComponent=  
        (<tr>
            <td><label for="passwordId">Password:</label></td>
            <td><input size="30" ref={passwordRef} type="password" id="passwordId"></input></td>
        </tr>);
    let submitButton = (<button onClick={submitSignIn}>Signon</button>);
    let resetPasswordButton =(<button onClick={submitPasswordReset}>Password Reset</button>);
    let staySignedOnComponent=(<></>);
    // if (status===sessionStatusStates.newUser){
    if (isNewUser){
        console.log("new user");
        confirmPasswordComponent = (<><tr>
                    {/* <td>Confirm Email address:</td><td><input ref={confirmEmailAddressRef} type="text"></input></td> */}
                    <td><label for="confirmPasswordId">Confirm Password:</label></td><td><input size="30" type="password" id="confirmPasswordId" ref={confirmPasswordRef} ></input></td>
                </tr></>);
        passwordComponent="";         
        submitButton = (<button onClick={submitPasswordReset}>Set Initial Password via email</button>);
        resetPasswordButton =(<></>);
    } else {
        staySignedOnComponent=(<>
            <td>
                <label for="stayOnId">Stay signed on </label>
                <input id="stayOnId" ref={sessionPersistanceRef} type="checkbox" defaultChecked onChange={sessionPersistanceChange}></input>    
            </td></>
        );
        
    }
   
    //else {
    //     const confirmEmailAddress = "";
    // }

    // function confirmEmailAddress() {
    //     if (status===sessionStatusStates.newUser){
    //         console.log("new user");
    //         return (<><tr>
    //                     <td>Confirm Email address:</td><td><input ref={emailAddressRef} type="text"></input></td>
    //                 </tr></>); 
    //     } else {
    //         return "";
    //     }          
    // }
    function isFieldsOK(email,password1,password2){
        let fieldOK=true;
        let message ="";
        if (email===null||email==""){
            message="Email address is missing.  "
            fieldOK=false;
        }
        if (password1===null||password1===""){
            message+="Password is missing.  ";
            fieldOK=false;
        }
        if (password1===seed){
            message+="Invalid choice of password.  ";
            fieldOK=false;
        }
        if(password2!==undefined&&(password2===null||password2==="")){
            message+="Confirmation password is missing.  ";
            fieldOK=false;
        }        
        if (fieldOK){
            return true;
        }
        alert(message+"Please enter missing information and try again.")
        return false;
    }
    return (
        <div>
            <h2>Signon to <i>Ohio Yearly Meeting Online</i></h2>
            <table>
            <tbody>
                <tr>
                    <td><label for="emailId">Email address:</label></td>
                    <td><input size="30" type="email" id="emailId" ref={emailAddressRef} ></input></td>
                </tr>
                {passwordComponent}
                {/* {confirmPasswordComponent} Deprecated                */}
                <tr>
                    <td>
                        <label for="newUserId">New User </label>
                        <input id="newUserId" ref={newUserRef} type="checkbox" onChange={newUserChange}></input>
                    </td>
                    {staySignedOnComponent}
                </tr>
                <tr>
                    <td>{submitButton} {resetPasswordButton}</td>
                </tr>
            </tbody>    
            </table>
            <hr></hr>
            <h3>First time users note:</h3>
            <ul>
                <li>Thy sign on id is thy email address.</li>
                <li>Signon is only available to members of Ohio Yearly Meeting whose email address in the OYM directory. If thy address is not in the directory, please contact thy Meeting's Recorder and provide it to them. Please be patient as thy address is stored in the directory and then propagated to this online system.</li>
                <li>Before signing on for the first time, thee will have to set up a password.</li>
                <li>To set up a password follow these instructions</li>
                    <ol>
                        <li>click the 'New User' checkbox.</li>
                        <li>Enter a thy email address and click on the button labled <i>Set Initial Password via email</i>. </li>
                        <li>Go to thy email system, open up the email from OYM Online.  
                            If no email arrives <i><b>check any spam mailbox thee may have.</b></i></li>
                        <li>Follow the instructions in the email.</li>
                    </ol>
                <li>After setting up thy password, enter thy email address and password into the signon screen.</li>                       
            </ul>
        </div>
    )
}
